import { Button, ButtonVariant, Modal, Typography } from '@/shared/ui';
import { NavigateFunction } from 'react-router';
import { ROUTES } from '../../../../../router/config';

type NoAccessWarningModalProps = {
  isModalOpen: boolean;
  navigate: NavigateFunction;
};

export const NoAccessWarningModal: React.FC<NoAccessWarningModalProps> = ({ isModalOpen, navigate }) => {
  return (
    <Modal
      open={isModalOpen}
      size="md"
      centered
      title="Немає доступу до послуги"
      onCancel={(): void => {
        navigate(ROUTES.INTERNAL_SERVICES);
      }}
      maskClosable={false}
      footer={
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'flex-start' }}>
          <Button
            onClick={(): void => {
              navigate(ROUTES.USER.PROFILE);
            }}
            variant={ButtonVariant.PRIMARY}
          >
            Особистий кабінет
          </Button>
          <Button
            onClick={(): void => {
              navigate(ROUTES.INTERNAL_SERVICES);
            }}
            variant={ButtonVariant.SECONDARY}
          >
            До послуг
          </Button>
        </div>
      }
    >
      <Typography as="p">
        Для замовлення послуги &quot;Страхування для власників зброї&quot; необхідно заповнити
        <br />
        всі обов&apos;язкові поля в особистому кабінеті.
      </Typography>
    </Modal>
  );
};
